<template>
  <v-list-item @click="$emit('itemClicked')" :disabled="disabled">
    <v-list-item-avatar v-if="avatar">
      <v-img :src="item.avatar"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title v-text="title"></v-list-item-title>
    </v-list-item-content>

    <v-list-item-icon v-if="icon">
      <v-icon :disabled="disabled">{{ icon }}</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    avatar: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-arrow-right'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>